// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3YLzd","icon":"SortAdornment_icon__1FEDe","up":"SortAdornment_up__1qH8i","down":"SortAdornment_down__36t5s","active":"SortAdornment_active__1ShdP"};